import styled from "styled-components";

export const MainContentsItemLayout = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
`;

export const MainContentsItem = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 21px;
  background: ${(props) => props.theme.colors.white};
  border-radius: 9px;
  box-shadow: ${(props) => props.theme.shadow.box};
  gap: 12px;
`;

export const DataItemBox = styled.p`
  padding: 0 10px 0 10px;
  font-size: 1.3rem;
  font-weight: 600;
  /* 줄바꿈을 방지합니다. */
  /* white-space: nowrap;  */
  /* 넘치는 부분을 숨깁니다. */
  /* overflow: hidden;  */
  /* 넘치는 부분을 ...으로 표현합니다. */
  /* text-overflow: ellipsis;  */
`;

export const DataHeadBox = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &.title {
    display: flex;
    flex-direction: row;
    font-weight: 600;
    align-items: end;
    justify-content: start;
    gap: 3px;
  }
`;

export const StyledText = styled.p`
  font-size: 1.4rem; /* 텍스트 크기를 조절합니다. */
  color: ${(props) => props.theme.colors.primary};
  font-weight: 500;
`;

export const ProfileDate = styled.p`
  width: 100%;
  color: ${(props) => props.theme.colors.placeholderTxt};
  font-size: 1.3rem;
  font-weight: 500;
  text-align: end;
`;
